import React from 'react'
import blackLogo from "../../assets/images/blackLogo.png"
import comLogo from "../../assets/images/comLogo.svg"
import flag from "../../assets/images/flag.png"
import log from "../../assets/images/log.png"
import commbitz from "../../assets/images/commbitz_logo.svg"
import tataneu from "../../assets/images/tataneu_logo.svg"
import { Link } from 'react-router-dom'

function Header() {
    return (
        <>
          <header>
            <div className="container">
              <span className="comlogo">
                <Link to='/'>
                  <span>
                    <img src={commbitz} alt="" />
                  </span>
                </Link> 
                <Link to='/'>
                  <span>
                    <img src={tataneu} alt="" />
                  </span>
                </Link>
              </span>
            </div>
          </header>
        </>
    )
}

export default Header